import { FormattedMessage } from 'react-intl';
import cx from 'clsx';
import type { ReactNode } from 'react';
import { usePdfPreviewContext } from '../../pdf-preview-context.tsx';
import type { Document } from '../../types';
import styles from './disclaimers.module.css';

interface DisclaimersProps {
  document: Document;
}

export function Disclaimers({ document }: DisclaimersProps): ReactNode {
  const { displayLanguage, isDraft, variant } = usePdfPreviewContext();

  const shouldDisplayStampDutyDisclaimer =
    document.stampDutyAmount && document.stampDutyAmount !== '0.00';
  const shouldDisplayDraftDisclaimer = variant === 'IT' && isDraft;

  if (shouldDisplayStampDutyDisclaimer || shouldDisplayDraftDisclaimer) {
    return (
      <div className={styles.disclaimers}>
        {shouldDisplayStampDutyDisclaimer ? (
          <p
            className={styles['stamp-duty-disclaimer']}
            data-testid="pdf-preview-stamp-duty-disclaimer"
          >
            <FormattedMessage
              id="pdf-preview.placerholder-stamp-duty"
              values={{ language: displayLanguage }}
            />
          </p>
        ) : null}
        {shouldDisplayDraftDisclaimer ? (
          <p
            className={cx('body-1', styles['draft-disclaimer'])}
            data-testid="pdf-preview-draft-disclaimer"
          >
            <FormattedMessage
              id="pdf-preview.draft.proforma-disclaimer"
              values={{ language: displayLanguage }}
            />
          </p>
        ) : null}
      </div>
    );
  }

  return null;
}
